const EHR_DATA = [
    {
        vendor: 'Connexions360',
        sent: 83248,
        engaged: 2237,
        cost: '$90',
        roi: ''
    },
    {
        vendor: 'RxNT',
        sent: 74099,
        engaged: 2064,
        cost: '$84',
        roi: ''

    }
];

const ENDEMIC_DISPLAY_DATA = [
    {
        vendor: 'Medscape',
        sent: 41440,
        engaged: 1963,
        cost: '$53',
        roi: ''
    },
    {
        vendor: 'OncLive',
        sent: 62352,
        engaged: 3518,
        cost: '$49',
        roi: ''

    },
    {
        vendor: 'Oncology Learning Network',
        sent: 44007,
        engaged: 2102,
        cost: '$51',
        roi: ''

    }
];

const PROGRAMMATIC_DATA = [
    {
        vendor: 'Deep Intent',
        sent: 128425,
        engaged: 4934,
        cost: '$59',
        roi: ''
    }
];

const eNewsletters_DATA = [
    {
        vendor: 'ACCC',
        sent: 3561,
        engaged: 1533,
        cost: '$31',
        roi: ''
    },
    {
        vendor: 'NCCN',
        sent: 3655,
        engaged: 1547,
        cost: '$30',
        roi: ''
    },
    {
        vendor: 'NEJM',
        sent: 3157,
        engaged: 1348,
        cost: '$32',
        roi: ''
    },
    {
        vendor: 'OncLive',
        sent: 2593,
        engaged: 1124,
        cost: '$34',
        roi: ''
    },
    {
        vendor: 'Oncology Learning Network',
        sent: 1209,
        engaged: 513,
        cost: '$30',
        roi: ''
    },
    {
        vendor: 'Sermo',
        sent: 2116,
        engaged: 994,
        cost: '$33',
        roi: ''
    }
];

const SALES_REP_DATA = [
    {
        channel: 'Face to Face',
        touchPoints: 15,
        engagments: 9
    },
    {
        channel: 'Video Calls',
        touchPoints: 27,
        engagments: 16
    },
    {
        channel: 'Phone Calls',
        touchPoints: 23,
        engagments: 13
    },
    {
        channel: 'Rep Triggered Digital',
        touchPoints: 89,
        engagments: 53
    }
];

const MARKET_ACCESS_DATA = [
    {
        channel: 'Face to Face',
        touchPoints: 18,
        engagments: 10
    },
    {
        channel: 'Video Calls',
        touchPoints: 25,
        engagments: 15
    },
    {
        channel: 'Phone Calls',
        touchPoints: 20,
        engagments: 12
    }
];

const MSL_DATA = [
    {
        channel: 'Face to Face',
        touchPoints: 19,
        engagments: 11
    },
    {
        channel: 'Video Calls',
        touchPoints: 27,
        engagments: 17
    },
    {
        channel: 'Phone Calls',
        touchPoints: 22,
        engagments: 14
    }
];



export const CHANNEL_COLUMNS = [
    'Vendor',
    'Sent',
    'Engaged',
    'Cost',
    'ROI'
];

export const VENDOR_COLUMNS = [
    '',
    'No. of Touchpoints	',
    'No. of Engagements'
];

export const CHANNELS_DATA = {
    'EHR': EHR_DATA,
    'Endemic Display': ENDEMIC_DISPLAY_DATA,
    'eNewsletters': eNewsletters_DATA,
    'Programmatic': PROGRAMMATIC_DATA
};

export const VENDORS_DATA = {
    'Sales Rep': SALES_REP_DATA,
    'Market Access - Account Managers': MARKET_ACCESS_DATA,
    'MSLs': MSL_DATA
};